import React, { useEffect, useState } from "react";
import PassportDetails from "./PassportDetails";
import { EnumPaxTitle, EnumPaxType, Passenger } from "../types/flights";

import { Form, Modal } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-date-picker";
import { toast } from "react-toastify";
import { CustomInput } from "../Common/Ui/CustomInput";
import { CustomStaticSelect } from "../Common/Ui/CustomStaticSelect";

const paxTypeArr = [
  {
    value: "Adult",
  },
  {
    value: "Child",
  },
  {
    value: "Infant",
  },
];

const titleArr = [
  {
    value: "Mr",
    label: "Mr.",
  },
  {
    value: "Mrs",
    label: "Mrs.",
  },
  {
    value: "Ms",
    label: "Ms.",
  },
  {
    value: "Miss",
    label: "Miss.",
  },
  {
    value: "Master",
    label: "Master.",
  },
  {
    value: "Dr",
    label: "Dr.",
  },
];

const FormModal: React.FC<{
  show: boolean;
  handleClose: () => void;
  saveHandler: (passenger: Passenger[]) => void;
  passengers: Passenger[];
}> = (props) => {
  const [passportDetails, setPassportDetails] = useState<Array<number>>([]);
  const [passengers, setPassengers] = useState<Passenger[]>(props.passengers);
  const insertPassenger = () => {
    setPassengers((old) => {
      old.push({
        firstName: "",
        lastName: "",
        title: "Mr",
        type: "Adult",
      });
      return [...old];
    });
  };

  const removePassenger = (index) => {
    setPassengers((old) => {
      old.splice(index, 1);
      return [...old];
    });
  };
  useEffect(() => {
    if (passengers.length < 1) {
      insertPassenger();
    }
  }, []);
  const handlePassChange = (index) => {
    setPassportDetails((old) => {
      old = old.filter((e) => e !== index);
      return old;
    });
  };
  const openPassportDetail = (index: number) => {
    setPassportDetails((old) => [...old, index]);
  };

  const validatePassenger = () => {
    for (let index in passengers) {
      const passenger = passengers[index];

      if (!passenger.firstName) {
        return toast.error(
          `Please enter first name for passenger ${parseInt(index) + 1}`
        );
      }

      // if (!passenger.DOB) {
      //   return toast.error(
      //     `Please enter DOB for passenger ${parseInt(index) + 1}`
      //   );
      // }

      if (
        (!passenger.passportNumber ||
          !passenger.passportCountry ||
          !passenger.passportExpiry) &&
        passportDetails.includes(parseInt(index))
      ) {
        return toast.error(
          "Please fill complete passport details or press cancel"
        );
      }
    }

    props.saveHandler(passengers);
  };

  return (
    <Modal centered size="xl" show={props.show}>
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Passenger Details
        </Modal.Title>
        <button className="btn" onClick={props.handleClose}>
          <i className="fa-solid fa-xmark"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-box">
          <div className="passenger-details">
            <div className="passenger-form-box">
              {passengers?.map((pass, index) => (
                <div className="bg-light px-3" key={index}>
                  <div className="text-end">
                    {passengers.length > 1 && (
                      <button
                        className="btn btn-sm btn-danger px-2"
                        onClick={() => removePassenger(index)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-lg-3">
                      <CustomStaticSelect
                        id="pax_type"
                        label="Pax Type"
                        value={pass.type}
                        onChange={(val) => {
                          setPassengers((old) => {
                            old[index].type = val?.target.value as EnumPaxType;
                            return [...old];
                          });
                        }}
                        optionArr={paxTypeArr}
                      />
                    </div>
                    <div className="col-lg-3">
                      <CustomStaticSelect
                        label="Title"
                        id="title"
                        value={pass.title}
                        onChange={(val) => {
                          setPassengers((old) => {
                            old[index].title = val?.target
                              .value as EnumPaxTitle;
                            return [...old];
                          });
                        }}
                        optionArr={titleArr}
                      />
                    </div>
                    <div className="col-lg-3">
                      <CustomInput
                        label="First Name"
                        id="f_name"
                        type="text"
                        value={pass.firstName}
                        onChange={(e) => {
                          setPassengers((old) => {
                            old[index].firstName = e.target.value;
                            return [...old];
                          });
                        }}
                      />
                    </div>
                    <div className="col-lg-3">
                      <CustomInput
                        label="Last Name"
                        id="l_name"
                        type="text"
                        value={pass.lastName}
                        onChange={(e) => {
                          setPassengers((old) => {
                            old[index].lastName = e.target.value;
                            return [...old];
                          });
                        }}
                      />
                    </div>
                    <div className="col-lg-3 mt-2">
                      <label htmlFor="">Date Of Birth</label>
                      <DatePicker
                        className="bg-white w-100  form-control"
                        value={
                          pass.DOB
                            ? moment(pass?.DOB, "YYYY-MM-DD").toDate()
                            : null
                        }
                        clearIcon={null}
                        onChange={(date) => {
                          setPassengers((old) => {
                            old[index].DOB = moment(date).format("YYYY-MM-DD");
                            return [...old];
                          });
                        }}
                        defaultValue={new Date()}
                        format="dd-MM-y"
                        dayPlaceholder="DD"
                        monthPlaceholder="MM"
                        yearPlaceholder="YYYY"
                        minDate={
                          pass.type === "Child"
                            ? moment().subtract(11, "years").toDate()
                            : pass.type === "Infant"
                            ? moment().subtract(1, "years").toDate()
                            : undefined
                        }
                        maxDate={
                          pass.type === "Adult"
                            ? moment().subtract(12, "years").toDate()
                            : pass.type === "Child"
                            ? moment().subtract(2, "years").toDate()
                            : moment().subtract(1, "day").toDate()
                        }
                      />
                    </div>
                    <div className="col-lg-9 mt-2">
                      {passengers[index].passportCountry ||
                      passengers[index].passportNumber ||
                      passportDetails.includes(index) ? (
                        <PassportDetails
                          index={index}
                          onChange={handlePassChange}
                          updateQuery={setPassengers}
                          pass={pass}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {!passportDetails.includes(index) && (
                    <button
                      className="btn small text-success mt-2"
                      onClick={() => openPassportDetail(index)}
                    >
                      + Add Passport
                    </button>
                  )}
                  {passengers.length - 1 !== index && <hr />}
                </div>
              ))}
            </div>

            <div className="text-end mt-3">
              <button
                className="btn btn-outline-success rounded"
                onClick={insertPassenger}
              >
                + Passenger
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary px-5" onClick={props.handleClose}>
          Close
        </button>
        <button
          className="btn btn-primary rounded px-5"
          onClick={validatePassenger}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default FormModal;
